import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  withProps,
  lifecycle,
  branch,
  pure,
  mapProps,
  renderNothing
} from 'recompose';

import NewsArticle from '../../views/News';
import { likeNews, favoriteNews, loadNewDetail } from '../../../actions';

export default compose(
  setDisplayName('NewContainer'),
  withProps(({ match }) => ({
    id: match.params.id
  })),
  connect(
    (state, { id }) => ({
      item: state.news.newsById[id],
      like: !state.news.newsLike ? false : !!state.news.newsLike.includes(id),
      favorite: !state.news.newsFavorite
        ? false
        : !!state.news.newsFavorite.includes(id)
    }),
    {
      loadNewDetail,
      onLike: likeNews,
      onFavorite: favoriteNews
    }
  ),
  lifecycle({
    componentDidMount() {
      const { id } = this.props;
      this.props.loadNewDetail(id);
    },
    componentDidUpdate(prevProps) {
      const { id } = this.props;

      // only update chart if the data has changed
      if (prevProps.id !== this.props.id) {
        this.props.loadNewDetail(id);
      }
    }
  }),
  branch(({ item }) => !item, renderNothing),
  mapProps(({ item, ...rest }) => ({
    ...item,
    ...rest
  })),
  pure
)(NewsArticle);
